let newBaseApi = process.env.REACT_APP_BASE_URL || `https://cms.quizard.live`;

export const apiUrl = {
    activityLog:`${newBaseApi}/api/v1/activity_log/`,
    getEventRules:`${newBaseApi}/api/rules/`
}
